import { Switch } from '@headlessui/react';
import { cn } from '@util/index';
import { cx } from 'class-variance-authority';

export default function Toggle({
  enabled,
  label,
  onChange,
  disabled,
  offLabel,
  onLabel,
  labelClassName,
}: {
  enabled: boolean;
  label?: string;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  offLabel?: string;
  onLabel?: string;
  labelClassName?: string;
}) {
  return (
    <div
      className={cx(
        'flex items-center gap-[0.8rem]',
        disabled ? 'pointer-events-none cursor-not-allowed opacity-50' : ''
      )}
    >
      {label && (
        <span
          className={cn(
            `font-semibold ${enabled ? 'text-brand-secondary' : 'text-black '}`,
            labelClassName
          )}
        >
          {label}
        </span>
      )}
      {offLabel && (
        <span className={`font-semibold text-black`}>{offLabel}</span>
      )}

      <Switch
        type="button"
        disabled={disabled}
        checked={enabled}
        onChange={onChange}
        className={cx(
          enabled ? 'bg-brand-secondary' : 'bg-[#7F7F7F]',
          'relative inline-flex h-[2.4rem] w-[4.4rem] flex-shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-1 focus:outline-brand-secondary'
        )}
      >
        <span className="sr-only">Use setting</span>

        <span
          aria-hidden="true"
          className={cx(
            enabled ? 'translate-x-[1.9rem]' : 'translate-x-0',
            'pointer-events-none flex h-[2rem] w-[2rem] transform items-center justify-center rounded-full bg-brand-white shadow-lg ring-0 transition duration-300 ease-out'
          )}
        />
      </Switch>
      {onLabel && (
        <span
          className={`font-semibold ${
            enabled ? 'text-brand-secondary' : 'text-black '
          }`}
        >
          {onLabel}
        </span>
      )}
    </div>
  );
}
